export default __webpack_public_path__ + "static/media/fross5.84a84d45.png";